import api from './api';

export const getOrders = () => api.get('/orders');
export const getOrdersStatisticsTable = () => api.get('/orders/statistics-table');
export const getOrder = (id) => api.get(`/orders/${id}`);
export const createOrder = (data) => api.post('/orders', data);
export const updateOrder = (id, data) => api.put(`/orders/${id}`, data);
export const deleteOrder = (id) => api.delete(`/orders/${id}`);
export const getOrderStatuses = () => api.get('/orders/statuses');
export const getDeliveryStatuses = () => api.get('/orders/delivery-statuses');
export const getDeliveryWindows = () => api.get('/delivery-windows');
// The invoice PDF attached to a manual status email is made by the server (services/invoice_pdf.py): nothing is uploaded from the browser.
export const updateDeliveryStatus = (id, data) => api.put(`/orders/${id}/delivery-status`, data);
export const getDeliveryStatusHistory = (id) => api.get(`/orders/${id}/delivery-status-history`);
export const updateShippingLabel = (id, data) => api.put(`/orders/${id}/shipping-label`, data);
export const getOrderTrackingLink = (id, box) => api.get(`/orders/${id}/tracking-link`, { params: box ? { box } : {} });
export const reprocessOrder = (id) => api.post(`/orders/${id}/reprocess`);
export const getMarketingReport = (scope) => api.get('/orders/marketing-report', { params: scope && scope !== 'all' ? { scope } : {} });
